
















































import { Component, Prop, Vue } from 'vue-property-decorator'
import LinkEx, { isExternalLink } from '../Parts/LinkEx.vue'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

/**
 * 動画データクラス
 */
export class News {
  private _title: string
  private _link: string
  private _tags: string[]
  private _startDate: string
  private _endDate: string
  private _description: string

  /**
   * コンストラクタ
   * @param title タイトル
   * @param link リンク先
   * @param tags タグリスト
   * @param startDate 日付
   * @param endDate 終了日付
   * @param description 説明
   */
  constructor(
    title: string,
    link: string,
    tags: string[],
    startDate: string,
    endDate: string,
    description = ''
  ) {
    this._title = title
    this._link = link
    this._tags = tags
    this._startDate = startDate
    this._endDate = endDate
    this._description = description
  }

  get title(): string {
    return this._title
  }

  get link(): string {
    return this._link
  }

  get tags(): string[] {
    return this._tags
  }

  get startDate(): string {
    return this._startDate
  }

  get endDate(): string {
    return this._endDate
  }

  get description(): string {
    return this._description
  }
}

@Component({
  components: { LinkEx, RemoveTag }
})
export default class NewsCard extends Vue {
  @Prop() private news!: News
  @Prop({
    default() {
      return []
    }
  })
  private addClass!: string[]

  // ------------------------------------------------------------------------------------------------
  // methods
  /**
   * 外部リンクか判定する
   */
  get isExternalLink(): boolean {
    return isExternalLink(this.news.link)
  }

  /**
   * リンクのクラスを取得する
   */
  get linkClass(): string[] {
    const addClass: string[] = this.addClass
    addClass.push('c-card__wrap')
    return addClass
  }
}
